'use client';

/**
 * Public auth context shape describing the authenticated user, loading state, and auth operations
 * (login, logout, refresh) used throughout web. Implemented via RTK Query in AuthContextRTK.
 */
export type { AuthContextValue, AuthProviderProps } from './AuthContextRTK';

/**
 * AuthProvider wires web to the RTK Query-backed authentication context. Wrap application
 * trees with this provider to expose `useAuth()` and `useAuthState()` to child components.
 * Always call `useAuth`/`useAuthState` within a descendant of AuthProvider.
 */
export { AuthProvider, useAuth, useAuthState } from './AuthContextRTK';
